import initMosaicGallery from '@/modules/misc/common/mosaic-gallery';

function track(view, eventData) {
  if (view === 'venuePage') {
    App.track.event('venue_page_interaction', eventData);
  } else {
    App.track.event('room_page_interaction', eventData);
  }
}

function initChangeSort(view) {
  $(document).on('change', 'select#reviewsOrder', function () {
    const val = $(this).val();

    let url = $(this).attr('data-url');
    if (val) {
      url += `?order=${val}`;
    }
    $('#reviews').load(url);

    track(view, {
      section: 'reviews_modal',
      element: 'sorting',
      element_value: val,
      interaction: 'click',
    });
  });
}

function initReviewPhotos(view) {
  let lightbox = null;

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox) {
      e.stopPropagation();
      lightbox.pswp.close();
    }
  }, true);

  $(document).on('click', '.reviews-modal-review__photos a', (e) => {
    e.preventDefault();
    const el = e.currentTarget;

    const index = parseInt(el.dataset.index, 10);
    let galleryData = el.closest('.reviews-modal-review__photos')?.dataset?.galleryItems;
    if (!galleryData) {
      return;
    }

    track(view, {
      section: 'reviews',
      element: 'photos_in_reviews',
      element_value: index,
      interaction: 'click',
    });

    galleryData = JSON.parse(galleryData);

    // global lightbox
    lightbox = initMosaicGallery(galleryData, {
      escKey: true,
    });

    lightbox.on('close', () => {
      $('.modal.fade.in').css('display', 'block');
      lightbox.destroy();
      lightbox = null;
    });

    lightbox.on('afterInit', () => {
      lightbox.on('change', () => {
        track(view, {
          section: 'reviews_photo_gallery',
          element: 'photo',
          element_value: lightbox.pswp.currIndex,
          interaction: 'change',
        });
      });
    });

    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'back',
        order: 1,
        isButton: false,
        appendTo: 'root',
        html: '<span class="pswp__back__label">Back</span>',
        onClick: () => {
          lightbox.pswp.close();
        },
      });

      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 2,
        isButton: false,
        appendTo: 'root',
        html: '',
        onInit: (element) => {
          lightbox.pswp.on('change', () => {
            element.innerHTML = lightbox.pswp.currSlide.data.caption;
          });
        },
      });
    });

    lightbox.init();
    lightbox.loadAndOpen(index);
    $('.modal.fade.in').css('display', 'none'); // hide modal to prevent FocusTrap issues
  });
}
export default function initReviewsModal(view) {
  initChangeSort(view);
  initReviewPhotos(view);
}
